import axios from "../../../util/axios";

const PREFIX_URI = "/project/dev/task";

export default {
    /** 任务看板数据 */
    queryBoard: (data) => axios.get({url: `${PREFIX_URI}/queryBoard`, data: data}),
    /** 所属项目下拉选项 */
    queryProjectOptions: () => axios.get({url: `${PREFIX_URI}/queryProjectOptions`}),
    /** 批次下拉选项（可按项目过滤） */
    querySprintOptions: (projectId) => axios.get({url: `${PREFIX_URI}/querySprintOptions`, data: {projectId: projectId}}),
    /** 保存任务（含关键节点，全量覆盖） */
    save: (data) => axios.post({url: `${PREFIX_URI}/save`, data: data}),
    /** 任务详情（含关键节点及测试人员） */
    detail: (id) => axios.get({url: `${PREFIX_URI}/detail`, data: {id: id}}),
    /** 任务状态流转 */
    updateStatus: (data) => axios.post({url: `${PREFIX_URI}/updateStatus`, data: data}),
    /** 填报进度 */
    reportProgress: (data) => axios.post({url: `${PREFIX_URI}/reportProgress`, data: data}),
    /** 提交任务延期信息（分类/说明/附件/天数） */
    saveDelayInfo: (data) => axios.post({url: `${PREFIX_URI}/saveDelayInfo`, data: data}),
    /** 任务日志 */
    queryTaskLogs: (taskId) => axios.get({url: `${PREFIX_URI}/queryTaskLogs`, data: {taskId: taskId}}),
};
